import { FiPhone, FiMail} from '../assets/icons/vander'


export const contactData = [
    {
        icon: FiPhone,
        title: 'Telefono',
        // desc: 'Promising development turmoil inclusive education transformative community',
        link:'+39 338 375 42 68',
        linkData: 'tel:+393383754268'
    },
    {
        icon: FiMail,
        title: 'Email',
        // desc: 'Promising development turmoil inclusive education transformative community',
        link:'vito.dalessandro2@gmail.com',
        linkData: 'mailto:vito.dalessandro2@gmail.com'
    },

]

